export const FETCH_APP_OPTIONS_FAILURE = 'FETCH_APP_OPTIONS_FAILURE';
export const FETCH_APP_OPTIONS_SUCCESS = 'FETCH_APP_OPTIONS_SUCCESS';
